var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "img",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 148,
    viewBox: "0 0 160 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Size_48_Theme_Neutral-Light_State_default_Background_Mask_",
    x: 32,
    y: 34,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f0f0f",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "img_Background_Mask_",
    "data-name": "img (Background/Mask)",
    width: 160,
    height: 148,
    rx: 12,
    fill: "#141416"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Size_48_Theme_Neutral-Light_State_default_Background_Mask_2",
    x: 32,
    y: 34,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0f0f0f",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Size_48_Theme_Neutral-Light_State_default_Background_Mask_)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Size_48_Theme_Neutral-Light_State_default_Background_Mask_3",
    "data-name": "Size=48, Theme=Neutral-Light, State=default (Background/Mask)",
    width: 48,
    height: 48,
    rx: 24,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Size_48_Theme_Neutral-Light_State_default_Background_Mask_Copy",
    "data-name": "Size=48, Theme=Neutral-Light, State=default (Background/Mask) Copy",
    width: 48,
    height: 48,
    rx: 24,
    fill: "#fcfcfd"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "img_Background_Mask_2",
    "data-name": "img (Background/Mask)",
    width: 160,
    height: 148,
    rx: 12,
    fill: "#141416"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img-2",
    "data-name": "img",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Size_48_Theme_Neutral-Light_State_default",
    "data-name": "Size=48, Theme=Neutral-Light, State=default",
    transform: "translate(56 50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Size_48_Theme_Neutral-Light_State_default-2",
    "data-name": "Size=48, Theme=Neutral-Light, State=default"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -56, -50)",
    filter: "url(#Size_48_Theme_Neutral-Light_State_default_Background_Mask_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Size_48_Theme_Neutral-Light_State_default_Background_Mask_4",
    "data-name": "Size=48, Theme=Neutral-Light, State=default (Background/Mask)",
    width: 48,
    height: 48,
    rx: 24,
    transform: "translate(56 50)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Size_48_Theme_Neutral-Light_State_default_Background_Mask_Copy-2",
    "data-name": "Size=48, Theme=Neutral-Light, State=default (Background/Mask) Copy",
    width: 48,
    height: 48,
    rx: 24,
    fill: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Size_48_Theme_Neutral-Light_State_default-4",
    "data-name": "Size=48, Theme=Neutral-Light, State=default",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_Play_Filled",
    "data-name": "icons/Play/Filled",
    transform: "translate(19.333 21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector_Stroke_",
    "data-name": "vector (Stroke)",
    d: "M7,.214,9.157,2.548a.667.667,0,0,1,0,.9L7,5.786a.667.667,0,0,1-.98-.9L7.144,3.667H.667a.667.667,0,1,1,0-1.333H7.144L6.023,1.119A.667.667,0,1,1,7,.214Z",
    transform: "translate(0 0)",
    fill: "#777e90"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.479ecde833b4415e714373af23db32ca.svg";
export { ForwardRef as ReactComponent };